"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_select_1 = __importDefault(require("react-select"));
const animated_1 = __importDefault(require("react-select/animated"));
const animatedComponents = (0, animated_1.default)();
const MultiSelect = ({ index, options, onChange, title, defaultValue }) => {
    const handleSelectChange = (newValue, actionMeta) => {
        const values = newValue.map(option => option.value);
        onChange({ [index]: values });
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: 'flex-1', children: [(0, jsx_runtime_1.jsx)("h3", { className: 'mb-1', children: title }), (0, jsx_runtime_1.jsx)(react_select_1.default, { defaultValue: defaultValue, closeMenuOnSelect: false, components: animatedComponents, isMulti: true, options: options, onChange: handleSelectChange })] }));
};
exports.default = MultiSelect;
